import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import classNames from "classnames";
import { BrowserRouter, Routes, Route, useLocation, Switch, useHistory } from "react-router-dom";
import { CSSTransition } from "react-transition-group";

import { AppTopbar } from "./AppTopbar";
import { AppFooter } from "./AppFooter";
import { AppMenu } from "./AppMenu";
import { AppConfig } from "./AppConfig";

import PrimeReact from "primereact/api";
import { Tooltip } from "primereact/tooltip";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import LoadingOverlay from "react-loading-overlay";
import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "./assets/demo/flags/flags.css";
import "./assets/demo/Demos.scss";
import "./assets/layout/layout.scss";
import "./App.scss";
import "./App.css";
import { useSelector } from "react-redux";
import { useContext } from "react";
import { AppContext } from "./ContextHook/AppContext";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "react-js-loader";
import { socket } from "./services/Socket";
import Login from "./pages/auth/Login";
import RegisterUser from "./pages/auth/RegisterUser";
import ForgetPassword from "./pages/auth/Forgetpassword";
import VerifyOTP from "./pages/auth/VerifyOTP";
import ResetPassword from "./pages/auth/ResetPassword";
import RideBooking from "./pages/passenger/booking/RideBooking";
import PassengerProfile from "./pages/shared/profile/Profile";
import MyRide from "./pages/passenger/myRides/MyRide";
import Faqs from "./pages/shared/faqs/Faqs";
import AddVehicle from "./pages/owner/vehicle/AddVehicle";
import Payment from "./pages/owner/payments/Payment";
import Documents from "./pages/owner/documents/Documents";
import VehicleDetails from "./pages/owner/vehicle/VehicleDetails";
import Corporate from "./pages/shared/corporate/Corporate";
import Wallet from "./pages/shared/wallet/Wallet";
import Support from "./pages/shared/support/Support";
import SupportChat from "./pages/shared/support/SupportChat";
import ProfileDetail from "./pages/shared/profile/ProfileDetail";
import NoVehicleFound from "./pages/owner/vehicle/NoVehicleFound";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import InviteFriends from "./pages/shared/inviteFriends/InviteFriends";
import Tutorials from "./pages/shared/tutorials/Tutorials";
import DetailRideCard from "./pages/components/DetailRideCard";
import ZindigiWallet from "./pages/shared/wallet/ZindigiLogin";
import DeLink from "./pages/shared/wallet/DeLink";
import Loading from "./pages/components/Loading";
import FeedbackComp from "./pages/components/Feedback";
import OTPVerification from "./pages/components/OTPVerification";
import Schedules from "./pages/owner/ownerSchedules/OwnerSchedules";
import RequestStatus from "./pages/owner/ownerSchedules/OwnerRequestStatus";
import RideStatus from "./pages/owner/ownerSchedules/OwnerRideStatus";
import DriverRide from "./pages/owner/ownerSchedules/DriverRide";
import { io } from "socket.io-client";
import { baseURL } from "./Config";
import { getSocket, SOCKET_ENDPOINTS } from "../src/services/Socket";
import PassengerRide from "./pages/owner/ownerSchedules/PassengerRide";
import { handleDecryptData } from "./services/DecryptionService";
import PayFast from "./pages/shared/wallet/PayFast";
import PrizeWheelGame from "./pages/game/prizeWheelGame";

const App = () => {
    const [layoutMode, setLayoutMode] = useState("static");
    const [layoutColorMode, setLayoutColorMode] = useState("light");
    const [inputStyle, setInputStyle] = useState("outlined");
    const [ripple, setRipple] = useState(true);
    const { staticMenuInactive, setStaticMenuInactive } = useContext(AppContext);
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false);
    const { onMenuItemClickContext, setOnMenuItemClickContext } = useContext(AppContext);
    const [selectedMenu, setSeletedMenu] = useState();
    const copyTooltipRef = useRef();
    const location = useLocation();
    const isLoading = useSelector((state) => state?.utilitySlice?.isLoading);
    const auth = useSelector((state) => state?.authenticationSlice?.token);
    const isLogin = useSelector((state) => state?.authenticationSlice?.login);
    const selectedUserType = useSelector((state) => state?.authenticationSlice?.selectedUserType);
    const userType = useSelector((state) => state?.authenticationSlice?.userType);
    const [switchAccount, setSwitchAccount] = useState(false);
    const [socketState, setSocketState] = useState(true);
    const [passengerNotification, setPassengerNotification] = useState();
    //    const getSocket = localStorage.getItem('newSocket')

    // const roles = localStorage.getItem("role") || 'super-admin';
    const history = useHistory();

    PrimeReact.ripple = true;
    const socket = getSocket();
    useEffect(() => {
        socket.on(SOCKET_ENDPOINTS.ERROR, (error) => {
            // toast.error(`Socket Error: ${error.msg}`);
            console.log(error.msg, "error");
        });

        return () => {
            socket.off(SOCKET_ENDPOINTS.ERROR);
        };
    }, [socket]);
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            socket.emit(SOCKET_ENDPOINTS.NEW_REQUEST, {}, (data) => {
                try {
                    const decryptedResponse = handleDecryptData(data?.cipher);
                    console.log(decryptedResponse, "decryptedResponse newRequest");
                    setPassengerNotification(decryptedResponse);
                } catch (error) {
                    console.error("Error while decrypting data:", error);
                }
            });
        }, 0); // Trigger immediately (or adjust timing if necessary)

        // Cleanup timeout
        return () => clearTimeout(timeoutId);
    }, [socket]);

    useEffect(() => {
        if (socket) {
            socket.on(SOCKET_ENDPOINTS.REFRESH_LIVE_LOCATION, (response) => {
                // handle response
            });
        }

        return () => {
            if (socket) {
                socket.off(SOCKET_ENDPOINTS.REFRESH_LIVE_LOCATION, (response) => {
                    // handle response
                });
            }
        };
    }, [socket]);

    let menuClick = false;
    let mobileTopbarMenuClick = false;

    useEffect(() => {
        if (mobileMenuActive) {
            addClass(document.body, "body-overflow-hidden");
        } else {
            removeClass(document.body, "body-overflow-hidden");
        }
    }, [mobileMenuActive]);

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    const onInputStyleChange = (inputStyle) => {
        setInputStyle(inputStyle);
    };

    const onRipple = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value);
    };

    const onLayoutModeChange = (mode) => {
        setLayoutMode(mode);
    };

    const onColorModeChange = (mode) => {
        setLayoutColorMode(mode);
    };

    const onWrapperClick = (event) => {
        if (!menuClick) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }

        if (!mobileTopbarMenuClick) {
            setMobileTopbarMenuActive(false);
        }

        mobileTopbarMenuClick = false;
        menuClick = false;
    };

    const onToggleMenuClick = (event) => {
        menuClick = true;

        if (isDesktop()) {
            if (layoutMode === "overlay") {
                if (mobileMenuActive === true) {
                    setOverlayMenuActive(true);
                }

                setOverlayMenuActive((prevState) => !prevState);
                setMobileMenuActive(false);
            } else if (layoutMode === "static") {
                setStaticMenuInactive((prevState) => !prevState);
            }
        } else {
            setMobileMenuActive((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const onSidebarClick = () => {
        menuClick = true;
    };

    const onMobileTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        setMobileTopbarMenuActive((prevState) => !prevState);
        event.preventDefault();
    };

    const onMobileSubTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        event.preventDefault();
    };

    const onMenuItemClick = (event) => {
        setOnMenuItemClickContext(event?.item?.label);
        if (!event.item.items) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }
    };
    const isDesktop = () => {
        return window.innerWidth >= 992;
    };

    const storedLoginRes = JSON.parse(localStorage.getItem("loginRes"));
    const userTypeIs = storedLoginRes?.userType;
    const userTypeId = storedLoginRes?._id;

    const handleLogOut = () => {
        localStorage.clear();
        window.location.reload();
    };

    const superAdminMenu = [
        {
            items: [
                {
                    label: "Home",
                    icon: "pi pi-fw pi-home",
                    to: "/home",
                },
                {
                    label: "Owner",
                    icon: "pi pi-fw pi-calendar",
                    to: "/owner-list",
                },
                {
                    label: "Corporate Code",
                    icon: "pi pi-fw pi-calendar",
                    to: "/corporate",
                },
                {
                    label: "Ads",
                    icon: "pi pi-fw pi-calendar",
                    to: "/advertisment",
                },
                {
                    label: "Verification",
                    icon: "pi pi-fw pi-calendar",
                    items: [
                        { label: "Personal ", to: "/personal" },
                        { label: "Vehicle", to: "/add-vehicle" },
                    ],
                },
                {
                    label: "Profile Setting",
                    icon: "pi pi-fw pi-cog",
                    to: "/passenger-profile",
                },
                {
                    label: "Wallet",
                    icon: "pi pi-fw pi-wallet",
                    to: "/wallet",
                },
                {
                    label: "History",
                    icon: "pi pi-fw pi-history",
                    to: "/history",
                },
                {
                    label: "Coporate",
                    icon: "pi pi-fw pi-building",
                    to: "/coporate",
                },
                {
                    label: "Support",
                    icon: "pi pi-fw pi-thumbs-up",
                    to: "/support",
                },
                {
                    label: "FAQs",
                    icon: "pi pi-fw pi-question",
                    to: "/faqs",
                },
                {
                    label: "Tutorial",
                    icon: "pi pi-fw pi-video",
                    to: "/faqs",
                },
                {
                    label: "Logout",
                    icon: "pi pi-sign-out",
                    command: () => handleLogOut(),
                },
            ],
        },
    ];

    const passengerMenuItem = [
        {
            items: [
                {
                    label: "Profile",
                    icon: "pi pi-fw pi-cog",
                    command: () => history.push("/profile-detail"),
                },
                {
                    label: "Schedules",
                    icon: "pi pi-car",
                    command: () => history.push("/schedules"),
                },
                {
                    label: "Book a Ride",
                    icon: "pi pi-map-marker",
                    command: () => history.push("/"),
                },

                {
                    label: "My Ride",
                    icon: "pi pi-inbox",
                    command: () => history.push("/my-ride"),
                },
                {
                    label: "Payment",
                    icon: "pi pi-money-bill",
                    command: () => history.push("/payment"),
                },
                {
                    label: "Wallet",
                    icon: "pi pi-wallet",
                    command: () => history.push("/wallet"),
                },
                {
                    label: "Corporate",
                    icon: "pi pi-briefcase",
                    command: () => history.push("/corporate"),
                },
                {
                    label: "Support",
                    icon: "pi pi-thumbs-up",
                    command: () => history.push("/support"),
                },
                {
                    label: "Invite Friends",
                    icon: "pi pi-user",
                    command: () => history.push("/invite-friends"),
                },
                {
                    label: "Tutorials",
                    icon: "pi pi-user",
                    command: () => history.push("/tutorials"),
                },
                {
                    label: "Logout",
                    icon: "pi pi-sign-out",
                    command: () => handleLogOut(),
                },
            ],
        },
    ];

    const ownerMenuItem = [
        {
            items: [
                {
                    label: "Profile",
                    icon: "pi pi-fw pi-cog",
                    command: () => history.push("/profile-detail"),
                },
                {
                    label: "Schedules",
                    icon: "pi pi-car",
                    command: () => history.push("/schedules"),
                },
                {
                    label: "Wallet",
                    icon: "pi pi-wallet",
                    command: () => history.push("/wallet"),
                },
                {
                    label: "Corporate",
                    icon: "pi pi-briefcase",
                    command: () => history.push("/corporate"),
                },
                {
                    label: "Support",
                    icon: "pi pi-thumbs-up",
                    command: () => history.push("/support"),
                },

                // owners
                {
                    label: "Vehicle",
                    icon: "pi pi-car",
                    command: () => history.push("/vehicle-detail"),
                },
                {
                    label: "Payment",
                    icon: "pi pi-money-bill",
                    command: () => history.push("/payment"),
                },
                {
                    label: "Documents",
                    icon: "pi pi-file",
                    command: () => history.push("/documents"),
                },
                {
                    label: "Invite Friends",
                    icon: "pi pi-user",
                    command: () => history.push("/invite-friends"),
                },
                {
                    label: "Tutorials",
                    icon: "pi pi-fw pi-cog",
                    command: () => history.push("/tutorials"),
                },
                {
                    label: "Logout",
                    icon: "pi pi-sign-out",
                    command: () => handleLogOut(),
                },
            ],
        },
    ];

    useLayoutEffect(() => {
        if (userType === "3") {
            let switchRole = {
                label: `Switch to ${selectedUserType === "1" ? "Passenger" : "Owner"}`,
                icon: "pi pi-sort-alt",
                command: () => setSwitchAccount(true),
            };
            // passengerMenuItem[0]?.items.splice(2, 0, switchRole)
            // ownerMenuItem[0].items?.splice(2, 0, switchRole)
        }
    }, [userType]);

    useLayoutEffect(() => {
        if (selectedUserType === "1") {
            setSeletedMenu(ownerMenuItem);
        } else {
            setSeletedMenu(passengerMenuItem);
        }
    }, [selectedUserType]);

    const handleCloseDialogBox = () => {
        if (!switchAccount) return;
        setSwitchAccount(false);
    };

    const handleSwitchRole = () => {
        if (selectedUserType === "1") {
            localStorage.setItem("selectedUserType", "2");
            setSwitchAccount(false);
            window.location.reload();
        } else {
            localStorage.setItem("selectedUserType", "1");
            setSwitchAccount(false);
            window.location.reload();
        }
    };

    const addClass = (element, className) => {
        if (element.classList) element.classList.add(className);
        else element.className += " " + className;
    };

    const removeClass = (element, className) => {
        if (element.classList) element.classList.remove(className);
        else element.className = element.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    };

    const wrapperClass = classNames("layout-wrapper", {
        "layout-overlay": layoutMode === "overlay",
        "layout-static": layoutMode === "static",
        "layout-static-sidebar-inactive": staticMenuInactive && layoutMode === "static",
        "layout-overlay-sidebar-active": overlayMenuActive && layoutMode === "overlay",
        "layout-mobile-sidebar-active": mobileMenuActive,
        "p-input-filled": inputStyle === "filled",
        "p-ripple-disabled": ripple === false,
        "layout-theme-light": layoutColorMode === "light",
    });

    useEffect(() => {
        const socket = getSocket();
        return () => {
            socket.disconnect();
        };
    }, []);

    // LoadingOverlay.propTypes = undefined;

    // Logout on Inactivity

    // Create a ref to store the interval ID
    const intervalRef = useRef();

    // Set up a function that checks the time since the user's last activity
    // and logs the user out if they have been inactive for too long
    // function checkActivity() {

    //     if (localStorage.getItem("login") === false || localStorage.getItem("login") === null) {
    //         return
    //     }
    //     console.log("here")
    //     const lastActive = localStorage.getItem('lastActive');
    //     const elapsed = Date.now() - lastActive;

    //     if (elapsed > 1800000) { // 5 minutes in milliseconds
    //         localStorage.removeItem('lastActive');
    //         localStorage.removeItem("login");
    //         localStorage.removeItem("user");
    //         history.push("/");
    //         window.location.reload();
    //         clearInterval(intervalRef.current);
    //     }
    // }

    // // Set up an interval to run the checkActivity function every minuteeee
    // useEffect(() => {
    //     intervalRef.current = setInterval(checkActivity, 1800000);
    //     return () => clearInterval(intervalRef.current);
    // }, []);

    // // Update the user's last active time whenever they interact with the page
    // useEffect(() => {

    //     function handleActivity() {
    //         localStorage.setItem('lastActive', Date.now());
    //     }
    //     window.addEventListener('click', handleActivity);
    //     window.addEventListener('keydown', handleActivity);
    //     window.addEventListener('mousemove', handleActivity);
    //     window.addEventListener('mousedown', handleActivity);
    //     window.addEventListener('scroll', handleActivity);
    //     window.addEventListener('keypress', handleActivity);

    //     return () => {
    //         window.removeEventListener('click', handleActivity);
    //         window.removeEventListener('keydown', handleActivity);
    //         window.removeEventListener('mousemove', handleActivity);
    //         window.removeEventListener('mousedown', handleActivity);
    //         window.removeEventListener('scroll', handleActivity);
    //         window.removeEventListener('keypress', handleActivity);
    //     };

    // }, []);

    // useEffect(()=>{

    // },[])

    return (
        <div className={wrapperClass} onClick={onWrapperClick}>
            {isLoading ? <Loading /> : null}

            <ToastContainer />
            <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />

            {isLogin && (
                <>
                    <AppTopbar onToggleMenuClick={onToggleMenuClick} layoutColorMode={layoutColorMode} mobileTopbarMenuActive={mobileTopbarMenuActive} onMobileTopbarMenuClick={onMobileTopbarMenuClick} onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick} />
                    {passengerNotification + "passneger "}
                    <div className="layout-sidebar" onClick={onSidebarClick}>
                        <AppMenu model={selectedMenu} onMenuItemClick={onMenuItemClick} layoutColorMode={layoutColorMode} />
                    </div>
                </>
            )}

            {!auth && !isLogin ? (
                <Switch>
                    <Route path="/" exact render={() => <Login />} />
                    <Route path="/register-user" exact render={() => <RegisterUser />} />
                    <Route path="/forgot-password" exact render={() => <ForgetPassword />} />
                    <Route path="/verify-otp" exact render={() => <VerifyOTP />} />
                    <Route path="/reset-password" exact render={() => <ResetPassword />} />
                    <Redirect to="/" />
                </Switch>
            ) : (
                <>
                    <div className="layout-main-container innr-Body">
                        <div className="layout-main card-section">
                            {selectedUserType == "1" ? (
                                <Switch>
                                    <Route path="/" exact render={() => <RideBooking />} />
                                    <Route path="/my-ride" exact render={() => <MyRide />} />
                                    <Route path="/passenger-profile" exact render={() => <PassengerProfile />} />
                                    <Route path="/profile-detail" exact render={() => <ProfileDetail />} />
                                    <Route path="/detail" exact render={() => <DetailRideCard />} />
                                    <Route path="/faq" exact render={() => <Faqs />} />
                                    <Route path="/corporate" exact render={() => <Corporate />} />
                                    <Route path="/game" exact render={() => <PrizeWheelGame />} />
                                    <Route path="/vehicle-detail" exact render={() => <VehicleDetails />} />
                                    <Route path="/add-vehicle" exact render={() => <AddVehicle />} />
                                    <Route path="/no-vehicle" exact render={() => <NoVehicleFound />} />
                                    <Route path="/payment" exact render={() => <Payment />} />
                                    <Route path="/documents" exact render={() => <Documents />} />
                                    <Route path="/corporate" exact render={() => <Corporate />} />
                                    <Route path="/support" exact render={() => <Support />} />
                                    <Route path="/support-chat" exact render={() => <SupportChat />} />
                                    <Route path="/wallet" exact render={() => <Wallet />} />
                                    <Route path="/wallet-zindigi-login" exact render={() => <ZindigiWallet />} />
                                    <Route path="/payfast" exact render={() => <PayFast />} />
                                    <Route path="/de-link" exact render={() => <DeLink />} />
                                    <Route path="/invite-friends" exact render={() => <InviteFriends />} />
                                    <Route path="/tutorials" exact render={() => <Tutorials />} />
                                    <Route path="/schedules" exact render={() => <Schedules />} />
                                    <Route path="/request-status" exact render={() => <RequestStatus />} />
                                    <Route path="/ride-status" exact render={() => <RideStatus />} />
                                    <Route path="/driver-ride" exact render={() => <DriverRide />} />
                                    <Route path="/feedback" exact render={() => <FeedbackComp />} />
                                    <Route path="/otppp" exact render={() => <OTPVerification />} />

                                    <Redirect to="/" />
                                </Switch>
                            ) : (
                                <Switch>
                                    <Route path="/my-ride" exact render={() => <MyRide />} />

                                    <Route path="/" exact render={() => <RideBooking />} />
                                    <Route path="/passenger-profile" exact render={() => <PassengerProfile />} />
                                    <Route path="/profile-detail" exact render={() => <ProfileDetail />} />
                                    <Route path="/detail" exact render={() => <DetailRideCard />} />
                                    <Route path="/my-ride" exact render={() => <MyRide />} />
                                    <Route path="/faq" exact render={() => <Faqs />} />
                                    <Route path="/corporate" exact render={() => <Corporate />} />
                                    <Route path="/game" exact render={() => <PrizeWheelGame />} />
                                    <Route path="/support" exact render={() => <Support />} />
                                    <Route path="/support-chat" exact render={() => <SupportChat />} />
                                    <Route path="/payment" exact render={() => <Payment />} />
                                    <Route path="/wallet" exact render={() => <Wallet />} />
                                    <Route path="/wallet-zindigi-login" exact render={() => <ZindigiWallet />} />
                                    <Route path="/payfast" exact render={() => <PayFast />} />
                                    <Route path="/de-link" exact render={() => <DeLink />} />
                                    <Route path="/invite-friends" exact render={() => <InviteFriends />} />
                                    <Route path="/tutorials" exact render={() => <Tutorials />} />
                                    <Route path="/schedules" exact render={() => <Schedules />} />
                                    <Route path="/request-status" exact render={() => <RequestStatus />} />
                                    <Route path="/ride-status" exact render={() => <RideStatus />} />
                                    <Route path="/driver-ride" exact render={() => <DriverRide />} />
                                    <Route path="/passenger-ride" exact render={() => <PassengerRide />} />
                                    <Route path="/otppp" exact render={() => <OTPVerification />} />
                                    <Redirect to="/" />
                                </Switch>
                            )}
                        </div>
                    </div>
                </>
            )}

            <AppConfig rip pleEffect={ripple} onRippleEffect={onRipple} inputStyle={inputStyle} onInputStyleChange={onInputStyleChange} layoutMode={layoutMode} onLayoutModeChange={onLayoutModeChange} layoutColorMode={layoutColorMode} onColorModeChange={onColorModeChange} />

            <CSSTransition classNames="layout-mask" timeout={{ enter: 200, exit: 200 }} in={mobileMenuActive} unmountOnExit>
                <div className="layout-mask p-component-overlay"></div>
            </CSSTransition>

            <Dialog className="surface-card dialog-card" header="Confirmation" visible={switchAccount} onHide={handleCloseDialogBox}>
                <div>
                    <p className="text-center">Are you sure want to switch Account</p>
                    <div className="flex justify-content-center mt-5">
                        <Button label="Yes" onClick={handleSwitchRole} />
                        <Button label="Cancel" className="delete-btn ml-3" onClick={() => setSwitchAccount(false)} />
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default App;
